import { hasSession } from '../auth/account.js';
import { state } from '../core/state.js';
import { esc } from '../core/text.js';
import { renderCurrency, saveProgress } from '../progress/xp.js';
import { cloudAdvBoard, cloudAdvDuel } from '../social/api.js';
import { publicProfileModal } from '../social/profile.js';
import { pushCloud } from '../sync/sync.js';
import { confetti } from '../ui/confetti.js';
import { fehlerBox, ladend, skelDuell, skelRangliste, wireErneut, zeigeInhalt, zeigeSkeleton } from '../ui/skeleton.js';
import { SFX, toast } from '../ui/toast.js';
import { ADV_GROUPS, ADV_ITEMS, ADV_SLOTS, ADV_WORLDS, ITEM_MAX, SLOT_ICON, slotChip } from './data.js';
import { ITEM_TIER_CLS, gRollLoot, itemBonusText } from './equip.js';
import { G, gItem, gQuestProgress, gStats } from './items.js';
import { RPG, advModal, renderAdventure, worldMeta } from './ui.js';
import { FOKUS_SPECIALS, worldStart } from './world.js';

/* ── Kompendium (Sammelalbum) ── */
export function kompendiumModal() {
  const g = G();
  // Gegner: pro Welt eigene Gruppe (3 Gegner + Boss)
  const foeCell = (name, img, found, boss) => `<div class="kp-cell ${found ? 'found' : 'locked'} ${boss ? 'boss' : ''}">
    <div class="kp-img"><img src="${RPG(img)}" alt="">${found ? '' : '<span class="kp-q">?</span>'}</div>
    <div class="kp-name">${found ? esc(name) : '???'}</div>${boss ? '<span class="kp-tag">Boss</span>' : ''}
  </div>`;
  let foeFound = 0, foeTotal = 0;
  const worldCells = ADV_WORLDS.map((W, wi) => {
    const w = wi + 1; const from = worldStart(w); const to = worldMeta(w).to;
    const reached = g.maxSection >= from; const bossFound = g.maxSection > to || g.examsBeaten > wi;
    foeTotal += W.enemies.length + 1; foeFound += (reached ? W.enemies.length : 0) + (bossFound ? 1 : 0);
    const cells = W.enemies.map((e) => foeCell(e.name, e.img, reached, false)).join('') + foeCell(W.boss.name, W.boss.img, bossFound, true);
    return `<div class="kp-group-h">🗺️ ${esc(W.name)} <small>Welt ${w}</small></div><div class="kp-grid">${cells}</div>`;
  }).join('');
  // Items: nach Set gruppiert
  const ids = Object.keys(ADV_ITEMS);
  const itemFound = ids.filter((id) => gItem(id)).length;
  const itemGroups = Object.keys(ADV_GROUPS).map((gid) => {
    const gi = ids.filter((id) => ADV_ITEMS[id].group === gid);
    const got = gi.filter((id) => gItem(id)).length;
    const cells = gi.map((id) => {
      const it = ADV_ITEMS[id]; const s = gItem(id); const found = !!s;
      return `<div class="kp-cell ${found ? 'found' : 'locked'}" title="${esc(ADV_SLOTS[it.slot])}">
        <span class="kp-slot slot-${it.slot}">${SLOT_ICON[it.slot]}</span>
        <div class="kp-img"><img src="${RPG(it.img)}" alt="">${found ? `<span class="kp-lv">St. ${s.level}</span>` : '<span class="kp-q">?</span>'}</div>
        <div class="kp-name">${found ? esc(it.name) : '???'}</div>
        <div class="kp-slotname">${esc(ADV_SLOTS[it.slot])}</div>
      </div>`;
    }).join('');
    const slotsInSet = [...new Set(gi.map((id) => ADV_ITEMS[id].slot))].sort((a, b) => Object.keys(ADV_SLOTS).indexOf(a) - Object.keys(ADV_SLOTS).indexOf(b));
    return `<div class="kp-group-h">${ADV_GROUPS[gid].icon} ${esc(ADV_GROUPS[gid].name)} <small>${got}/${gi.length}</small><span class="inv-group-slots">${slotsInSet.map(slotChip).join('')}</span></div><div class="kp-grid">${cells}</div>`;
  }).join('');
  advModal('📖 Kompendium – Sammelalbum',
    `<div class="kp-tabs"><button class="kp-tab active" data-kp="items">Lernbegleiter <b>${itemFound}/${ids.length}</b></button><button class="kp-tab" data-kp="foes">Gegner &amp; Welten <b>${foeFound}/${foeTotal}</b></button></div>
     <div class="kp-pane" id="kp-items">${itemGroups}</div>
     <div class="kp-pane" id="kp-foes" hidden>${worldCells}</div>`, 'wide');
  const ov = document.querySelector('.adv-modal-ov:last-child');
  ov.querySelectorAll('[data-kp]').forEach((b) => b.onclick = () => {
    ov.querySelectorAll('.kp-tab').forEach((t) => t.classList.toggle('active', t === b));
    ov.querySelector('#kp-items').hidden = b.dataset.kp !== 'items';
    ov.querySelector('#kp-foes').hidden = b.dataset.kp !== 'foes';
  });
}

/* ── Abenteuer-Bestenliste ── */
export async function advLeaderboardModal() {
  if (!hasSession()) { toast('Melde dich an, um die Bestenliste zu sehen.'); return; }
  const ov = advModal('🏆 Abenteuer-Bestenliste', skelRangliste(8), 'wide');
  const body = ov.querySelector('.adv-modal-body');
  ladend(body, true);
  try { await pushCloud(); } catch (e) {}
  try {
    let sort = 'section';
    const load = async () => {
      // Beim Umschalten der Sortierung bleibt die Liste ein Skeleton in
      // derselben Höhe – vorher schrumpfte das Popup auf eine Zeile.
      zeigeSkeleton(body, skelRangliste(8));
      const res = await cloudAdvBoard(sort);
      ladend(body, false);
      const rows = (res.entries || []).map((e) => `<div class="alb-row ${e.me ? 'me' : ''}">
        <span class="alb-rank">${e.rank <= 3 ? ['🥇', '🥈', '🥉'][e.rank - 1] : e.rank}</span>
        <span class="alb-name" data-uid="${e.user_id}">${esc(e.name || e.username || 'Anonym')}</span>
        <span class="alb-val">${sort === 'atk' ? '⚔ ' + (e.atk_power || 0) : sort === 'level' ? '✦ Stufe ' + (e.char_lvl || 1) : '📖 Abschnitt ' + (e.max_section || 1)}</span>
      </div>`).join('') || '<p class="adv-modal-sub">Noch keine Einträge – lerne und komm auf die Liste!</p>';
      body.innerHTML = `<div class="alb-tabs">
        <button class="alb-tab ${sort === 'section' ? 'active' : ''}" data-s="section">Weitester Abschnitt</button>
        <button class="alb-tab ${sort === 'atk' ? 'active' : ''}" data-s="atk">Angriffskraft</button>
        <button class="alb-tab ${sort === 'level' ? 'active' : ''}" data-s="level">Lernstufe</button>
      </div>
      <p class="adv-modal-sub">Dein Rang: <b>#${res.myRank || '–'}</b></p>
      <div class="alb-list">${rows}</div>`;
      body.querySelectorAll('[data-s]').forEach((b) => b.onclick = () => { sort = b.dataset.s; load(); });
      body.querySelectorAll('[data-uid]').forEach((b) => b.onclick = () => publicProfileModal(b.dataset.uid));
    };
    await load();
  } catch (e) {
    zeigeInhalt(body, fehlerBox('Die Bestenliste konnte nicht geladen werden: ' + e.message));
    wireErneut(body, () => advLeaderboardModal());
  }
}

/* ── Freundesduell: wer kommt diese Woche am weitesten? ── */
export async function advDuelModal() {
  if (!hasSession()) { toast('Melde dich an und füge Freunde hinzu, um zu duellieren.'); return; }
  const ov = advModal('⚔️ Freundesduell dieser Woche', skelDuell(4));
  const body = ov.querySelector('.adv-modal-body');
  ladend(body, true);
  try { await pushCloud(); } catch (e) {}
  try {
    const res = await cloudAdvDuel();
    ladend(body, false);
    const list = (res.entries || []).slice().sort((a, b) => (b.week_adv || 0) - (a.week_adv || 0));
    if (!list.length) { body.innerHTML = '<p class="adv-modal-sub">Füge im Community-Tab Freunde hinzu – dann tretet ihr hier jede Woche gegeneinander an!</p>'; return; }
    const max = Math.max(1, ...list.map((e) => e.week_adv || 0));
    const rows = list.map((e, i) => `<div class="duel-row ${e.me ? 'me' : ''}">
      <span class="duel-rank">${i === 0 ? '👑' : i + 1}</span>
      <span class="duel-name" ${e.me ? '' : `data-uid="${e.user_id}"`}>${esc(e.name || e.username || 'Anonym')}${e.me ? ' (du)' : ''}</span>
      <span class="duel-bar"><i style="width:${Math.round((e.week_adv || 0) / max * 100)}%"></i></span>
      <span class="duel-val">+${e.week_adv || 0}</span>
    </div>`).join('');
    body.innerHTML = `<p class="adv-modal-sub">Wer schafft <b>diese Woche</b> die meisten neuen Abschnitte? Zählung endet Sonntag.</p>
      <div class="duel-list">${rows}</div>`;
    body.querySelectorAll('[data-uid]').forEach((b) => b.onclick = () => publicProfileModal(b.dataset.uid));
  } catch (e) {
    zeigeInhalt(body, fehlerBox('Das Duell konnte nicht geladen werden: ' + e.message));
    wireErneut(body, () => advDuelModal());
  }
}

/* ── Live-Idle-Ticker (nur wenn der Reiter offen ist) ── */
export let advTimer = null, advCoinAcc = 0, advSaveTick = 0;
export function advStartTick() { clearInterval(advTimer); advTimer = setInterval(advTick, 3000); }
export function advTick() {
  const g = G();
  if (state.view !== 'adventure' || !g.on) { clearInterval(advTimer); advTimer = null; return; }
  const now = Date.now();
  if (!g.lastTick) g.lastTick = now;
  const dtMin = Math.min((now - g.lastTick) / 60000, 0.1);
  g.lastTick = now;
  const st = gStats();
  let decay = 1;
  if (g.lastStudy) { const days = (now - g.lastStudy) / 86400000; if (days > 7) decay = 0.1; else if (days > 2) decay = 0.5; }
  advCoinAcc += st.coinsPerMin * dtMin * decay;
  if (advCoinAcc >= 1) {
    const add = Math.floor(advCoinAcc); advCoinAcc -= add;
    state.progress.coins += add; renderCurrency();
    const chip = document.querySelector('#view-adventure .adv-top .adv-chip:last-child');
    if (chip) chip.innerHTML = `<img src="assets/icon_coin.png" alt="">${state.progress.coins}`;
    if (++advSaveTick % 5 === 0) saveProgress();
  }
}

/* ── Schwebende Schadenszahl beim Lernen ── */
export function advFloatDmg(hit) {
  if (!hit) return;
  const host = document.getElementById('stage'); if (!host) return;
  const el = document.createElement('div');
  el.className = 'dmg-float' + (hit.crit ? ' crit' : '');
  el.textContent = (hit.crit ? '✦ ' : '') + '-' + hit.dmg;
  el.style.left = (35 + Math.random() * 30) + '%';
  host.appendChild(el);
  setTimeout(() => el.remove(), 950);
  if (hit.fokus && hit.special) {
    const s = FOKUS_SPECIALS[hit.special];
    toast(`${s.icon} ${s.name}!` + (hit.goldRush ? ` +${hit.goldRush} Münzen` : ''));
  }
  if (hit.shieldBroke) toast('🛡️💥 Boss-Schild zerbrochen – jetzt voller Schaden!');
  else if (hit.shieldHit) toast(`🛡️ Boss-Schild hält (noch ${hit.shield})`);
  if (hit.defeated) {
    toast(hit.exam ? `🏆 Prüfung bestanden! +${hit.reward} Münzen` : `💥 Hindernis besiegt! +${hit.reward} Münzen`);
    if (hit.carried) setTimeout(() => toast(`⛓️ Kettenschlag trifft das nächste Hindernis (-${hit.carried})`), 500);
    if (hit.chest) setTimeout(() => toast('🎁 Eine Schatztruhe gefunden!'), 750);
  }
}

/* ── Lootbox öffnen: bei mehreren Truhen fragt ein Popup, wie viele auf einmal. ── */
export function advOpenChest() {
  const g = G();
  if (g.chests <= 0) { toast('Noch keine Truhe – besiege Lernhindernisse beim Lernen!'); return; }
  if (g.chests === 1) { advOpenChests(1); return; }
  const opts = [1, 5, 10, 20].filter((x) => x < g.chests);
  const btns = opts.map((x) => `<button class="btn-secondary chest-n" data-n="${x}">${x} öffnen</button>`).join('')
    + `<button class="btn-primary chest-n" data-n="${g.chests}">Alle ${g.chests} öffnen</button>`;
  const ov = advModal('🎁 Schatztruhen öffnen', `<p class="adv-modal-sub">Du hast <b>${g.chests}</b> Schatztruhen. Wie viele möchtest du auf einmal öffnen? Alle Belohnungen erscheinen zusammen.</p><div class="chest-choose">${btns}</div>`);
  ov.querySelectorAll('[data-n]').forEach((b) => b.onclick = () => { ov.remove(); advOpenChests(parseInt(b.dataset.n, 10)); });
}
export function advOpenChests(n) {
  const g = G(); if (g.chests <= 0) return;
  n = Math.max(1, Math.min(n, g.chests));
  g.chests -= n; gQuestProgress('chest', n);
  const loots = [];
  for (let c = 0; c < n; c++) { const cnt = 2 + Math.floor(Math.random() * 2) + (Math.random() < 0.3 ? 1 : 0); for (let k = 0; k < cnt; k++) loots.push(gRollLoot()); }
  saveProgress(); renderCurrency();
  const ov = document.createElement('div');
  ov.className = 'chest-ov';
  ov.innerHTML = '<div class="chest-stage"><img class="chest-img" src="' + RPG('chest0.png') + '"></div>';
  document.body.appendChild(ov);
  const img = ov.querySelector('.chest-img');
  const frames = ['chest0.png', 'chest1.png', 'chest2.png', 'chest3.png'];
  let i = 0; try { SFX.flip(); } catch (e) {}
  const anim = setInterval(() => {
    i++;
    if (i < frames.length) { img.src = RPG(frames[i]); try { SFX.flip(); } catch (e) {} }
    else {
      clearInterval(anim);
      try { SFX.unlock(); } catch (e) {} confetti();
      const inner = n === 1
        ? `<div class="loot-multi">${loots.map((l, k) => `<div class="loot-slot" style="animation-delay:${k * 0.3}s">${lootRewardHTML(l)}</div>`).join('')}</div>`
        : advBulkLootHTML(loots);
      ov.querySelector('.chest-stage').innerHTML =
        (n > 1 ? `<div class="chest-reveal-h">🎁 ${n} Truhen geöffnet!</div>` : '')
        + inner + '<button class="btn-primary chest-close">Einsammeln ✦</button>';
      if (n === 1) loots.forEach((l, k) => setTimeout(() => { try { l.type === 'item' && l.rarity.key === 'legend' ? SFX.win() : SFX.unlock(); } catch (e) {} }, k * 300 + 120));
      ov.querySelector('.chest-close').onclick = () => { ov.remove(); renderAdventure(); };
    }
  }, 300);
}
/* Sammel-Ansicht: alle Belohnungen zusammengefasst (Items gestapelt + Ressourcen-Chips). */
export function advBulkLootHTML(loots) {
  const items = {}; let coins = 0, gems = 0, focus = 0;
  loots.forEach((l) => {
    if (l.type === 'item') { const e = items[l.id] || (items[l.id] = { id: l.id, item: l.item, copies: 0, level: l.level, isNew: false }); e.copies += l.copies; e.level = l.level; e.isNew = e.isNew || l.isNew; }
    else if (l.type === 'coins') coins += l.amount; else if (l.type === 'gems') gems += l.amount; else if (l.type === 'focus') focus += l.amount;
  });
  const itemCards = Object.values(items).sort((a, b) => b.level - a.level).map((e) => {
    const cls = ITEM_TIER_CLS[e.level - 1] || 'r-common';
    return `<div class="loot-reward ${cls} bulk">
      <div class="loot-rar">×${e.copies}${e.isNew ? ' · NEU' : ''}</div>
      <div class="loot-frame"><img src="${RPG(e.item.img)}" alt=""></div>
      <b class="loot-name">${esc(e.item.name)}</b>
      <div class="loot-desc">Stufe ${e.level}/${ITEM_MAX} · ${itemBonusText(e.id, e.level)}</div>
    </div>`;
  }).join('');
  const chips = [];
  if (coins) chips.push(`<span class="bulk-chip"><img src="assets/icon_coin.png" alt="">+${coins}</span>`);
  if (gems) chips.push(`<span class="bulk-chip"><img src="assets/icon_gem.png" alt="">+${gems}</span>`);
  if (focus) chips.push(`<span class="bulk-chip">🎯 +${focus} Fokus</span>`);
  return `<div class="loot-multi bulk">${itemCards || '<p class="bulk-none">Nur Ressourcen erhalten.</p>'}</div>${chips.length ? `<div class="bulk-chips">${chips.join('')}</div>` : ''}`;
}
export function lootRewardHTML(loot) {
  if (loot.type === 'item') {
    const it = loot.item; const tierCls = ITEM_TIER_CLS[loot.level - 1] || 'r-common';
    const head = loot.isNew ? '✨ Neuer Lernbegleiter!' : (loot.overflow > 0 ? 'Bereits Stufe 5 – Rest in Münzen' : '⬆ Item verstärkt!');
    return `<div class="loot-reward ${tierCls}">
      <div class="loot-rar">${loot.rarity.name} · ×${loot.copies}</div>
      <div class="loot-frame"><img src="${RPG(it.img)}" alt=""></div>
      <b class="loot-name">${esc(it.name)}</b>
      <div class="loot-desc">${head}<br>Stufe ${loot.level} / ${ITEM_MAX} · ${itemBonusText(loot.id, loot.level)}</div>
    </div>`;
  }
  if (loot.type === 'coins') return `<div class="loot-reward r-common"><div class="loot-frame plain"><img src="${RPG('reward.png')}" alt=""></div><b class="loot-name">+${loot.amount} Wissensmünzen</b></div>`;
  if (loot.type === 'focus') return `<div class="loot-reward r-rare"><div class="loot-frame plain">🎯</div><b class="loot-name">+${loot.amount} Fokus</b></div>`;
  return `<div class="loot-reward r-legend"><div class="loot-frame plain"><img src="assets/icon_gem.png" alt=""></div><b class="loot-name">+${loot.amount} Erinnerungsdiamant${loot.amount > 1 ? 'en' : ''}</b></div>`;
}

/* ── Welt befreit! (nach Boss-Sieg) ── */
export function advWorldClearOverlay(hit) {
  const ov = document.createElement('div'); ov.className = 'adv-intro-ov world-clear-ov';
  const rewardLine = `<img src="assets/icon_coin.png" alt="">+${hit.reward}${hit.gems ? ` · <img src="assets/icon_gem.png" alt="">+${hit.gems}` : ''}${hit.chest ? ' · 🎁 +1 Truhe' : ''}`;
  ov.innerHTML = `<div class="adv-intro-card small world-clear">
    <div class="wc-crown">🏆</div>
    <h3>Welt befreit!</h3>
    <p><b>${esc(hit.worldName)}</b> ist bezwungen – der Boss ist besiegt und das Wissen gerettet! 🎉</p>
    <div class="wc-reward">${rewardLine}</div>
    <p class="wc-next">Es geht weiter nach <b>${esc(hit.nextWorldName)}</b> 🗺️</p>
    <button class="btn-primary adv-intro-go">Nächste Welt betreten →</button>
  </div>`;
  document.body.appendChild(ov);
  try { SFX.win(); confetti(); } catch (e) {}
  ov.querySelector('.adv-intro-go').onclick = () => { ov.remove(); if (state.view === 'adventure') renderAdventure(); };
}

/* ── Intro-Comic beim ersten Öffnen ── */
export function advIntro() {
  const g = G(); if (g.intro) return;
  g.intro = true; saveProgress();
  const ov = document.createElement('div');
  ov.className = 'adv-intro-ov';
  ov.innerHTML = `<div class="adv-intro-card">
    <img class="adv-intro-img" src="${RPG('intro.jpg')}" alt="Mimorios Wissensabenteuer">
    <div class="adv-intro-text">
      <h3>Die Bibliothek der Erinnerungen 📖</h3>
      <p>Der <b>Vergessensnebel</b> lässt gelerntes Wissen verblassen. Mit jeder Karteikarte, die du lernst, hilfst du Mimorio, verlorene Erinnerungen zurückzuholen und Lernhindernisse zu überwinden.</p>
      <button class="btn-primary adv-intro-go">Los geht’s! 🐱</button>
    </div>
  </div>`;
  document.body.appendChild(ov);
  ov.querySelector('.adv-intro-go').onclick = () => ov.remove();
}

/* ── „Willkommen zurück" (Offline-Sammlung) ── */
export function gShowOffline(res) {
  const ov = document.createElement('div');
  ov.className = 'adv-intro-ov';
  const decayNote = res.decay < 1 ? `<p class="page-sub">Weil du länger nicht gelernt hast, war die Bibliothek etwas dunkler (${Math.round(res.decay * 100)}%). Lern wieder, dann leuchtet sie voll!</p>` : '';
  ov.innerHTML = `<div class="adv-intro-card small">
    <img class="adv-offline-img" src="${RPG('reward.png')}" alt="">
    <div class="adv-intro-text">
      <h3>Mimorio hat Wissen gesammelt! 🐱</h3>
      <p>Während du weg warst (${res.minutes >= 60 ? Math.round(res.minutes / 60) + ' h' : res.minutes + ' min'}${res.capped ? ', gedeckelt' : ''}) hat Mimorio die Bibliothek sortiert und <b>${res.coins} Wissensmünzen</b> gefunden.</p>
      ${decayNote}
      <button class="btn-primary adv-intro-go">Einsammeln ✦</button>
    </div>
  </div>`;
  document.body.appendChild(ov);
  ov.querySelector('.adv-intro-go').onclick = () => ov.remove();
}

